// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__95cph","title":"Info_title__3hz_a","links":"Info_links__1R3_d","link":"Info_link__3aXAg","logo":"Info_logo__h69s5"};